import { LIST_RESIZE } from './constants'

export function findSizeId(width: number, height: number, returnIcon: true): { sizeId: string | null; icon: any }
export function findSizeId(width: number, height: number, returnIcon?: false): string | null
export function findSizeId(width: number, height: number, returnIcon = false): string | null | { sizeId: string | null; icon: any } {
  let sizeId: string | null = null
  let icon: any = null
  LIST_RESIZE.forEach((groupItem) => {
    const key = Object.keys(groupItem)[0]
    if (sizeId === null) {
      groupItem[key].forEach((sizeItem) => {
        if (sizeItem.size && sizeItem.size.width === width && sizeItem.size.height === height && !sizeId) {
          sizeId = `${sizeItem.id}_${sizeItem.name}`
          icon = sizeItem.icon
        }
      })
    }
  })
  if (returnIcon) {
    return { sizeId, icon }
  }
  return sizeId
}
